<template>
  <div>
    <NavBar />
    <AuthBySessionExpired />
    <AddDevice @created="getDevices" />
    <ViewDevice :device="device" @updated="getDevices" @close="device = null" />
    <div class="container">
      <b-overlay :show="loading" opacity="0.99">
        <div class="container-fluid">
          <b-row align-h="between" align-v="center">
            <b-col cols="auto">
              <h1 class="title-pages">DISPOSITIVOS</h1>
            </b-col>
            <b-col cols="auto">
              <v-btn class="btn-add" @click="$bvModal.show('modal_add_device')">
                <i class="fas fa-plus mr-2 text-twenty"></i> ADICIONAR
              </v-btn>
            </b-col>
          </b-row>
          <b-row align-h="between" align-v="center">
            <b-col cols="4">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="PESQUISAR"
                outlined
                dense
                hide-details
              />
            </b-col>
            <b-col cols="auto">
              <v-checkbox
                label="MOSTRAR INATIVOS"
                hide-details
                v-model="show_inactive"
                @change="getDevices"
              >
              </v-checkbox>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <v-data-table
                dense
                :search="search"
                :headers="headers"
                :items="devices"
                :footer-props="{
                  'items-per-page-options': [50, 75, 100],
                  'items-per-page-text': 'Mostrar',
                }"
              >
                <template v-slot:[`item.allowed_by`]="{ item }">
                  {{ item.allowed_by ? item.allowed_by : "ADMINISTRADOR" }}
                </template>
                <template v-slot:[`item.code`]="{ item }">
                  {{ item.code == null ? "Já utilizada" : item.code }}
                </template>
                <template v-slot:[`item.status`]="{ item }">
                  {{ item.status == 1 ? "Liberado" : "Bloqueado" }}
                </template>
                <template v-slot:[`item.last_login`]="{ item }">
                  {{
                    item.last_login
                      ? `${item.last_login_name} em ${formatDate(
                          item.last_login,
                          true
                        )}`
                      : "Não acessado"
                  }}
                </template>
                <template v-slot:[`item.created_at`]="{ item }">
                  {{ formatDate(item.created_at, false) }}
                </template>
                <template v-slot:[`item.updated_at`]="{ item }">
                  {{ formatDate(item.updated_at, false) }}
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-btn class="btn-edit m-1" small @click="device = item">
                    <i class="fas fa-pencil-alt mr-2 text-twenty" />
                    EDITAR
                  </v-btn>
                </template>
              </v-data-table>
            </b-col>
          </b-row>
          <b-row>
            <b-col> Meu dispositivo: {{ device_code() }} </b-col>
          </b-row>
          <ErrorsMessages :errors="errors" />
        </div>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";
import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";
import AddDevice from "../templates/Devices/AddDevice";
import ViewDevice from "../templates/Devices/ViewDevice.vue";
import ErrorsMessages from "../templates/Components/ErrorsMessages";
import api from "../services/api";
import { formatDate } from "../lib/format";
import permission from "../lib/permission";

export default {
  name: "Devices",

  components: {
    NavBar,
    AuthBySessionExpired,
    AddDevice,
    ViewDevice,
    ErrorsMessages,
  },

  data() {
    return {
      errors: [],
      loading: false,

      device: null,

      search: "",
      headers: [
        { text: "Dispositivo", value: "name" },
        { text: "Concessor", value: "allowed_by" },
        { text: "Chave", value: "code" },
        { text: "Status", value: "status" },
        { text: "Último acesso", value: "last_login" },
        { text: "Registrado", value: "created_at" },
        { text: "Modificado", value: "updated_at" },
        { text: "Ações", value: "actions" },
      ],
      devices: [],
      show_inactive: false,
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    permission,
    formatDate,

    async retrieve() {
      this.getDevices();
    },

    async getDevices() {
      try {
        this.loading = true;

        let { rest_home_id, show_inactive } = this;
        let params = { rest_home_id, show_inactive };

        let response = await api.get("/rest-home/devices/paginate", {
          params,
        });
        let { error, errors, devices } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.devices = devices;
          this.errors = [];
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    device_code() {
      return localStorage.getItem("device_code");
    },
  },
};
</script>

<style>
.v-input--checkbox,
.v-input--checkbox .v-input__slot,
.v-input--checkbox .v-input__slot .v-label {
  padding: 0;
  margin: 0;
}
</style>
